// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./ListBoxOptionTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListBoxOption-module__Container__y7Ic9 {
    display: flex;
    gap: var(--ds-s);
    align-items: center;
    justify-content: center;
    padding: var(--ds-s) var(--ds-sm);
    background-color: var(--ds-listbox-option-bg-color);
    border: var(--ds-border-width) solid var(--ds-listbox-option-border-color);
    border-radius: var(--ds-xl);
    cursor: pointer;

    &:hover {
        background-color: var(--ds-listbox-option-hover-bg-color);
    }

    &:focus-visible {
        border: var(--ds-border-width-double) solid
            var(--ds-listbox-option-focused-border-color);
        outline: none;
    }
}

.ListBoxOption-module__OptionSelected__w5EqJ {
    border: var(--ds-border-width) solid
        var(--ds-listbox-option-selected-border-color);

    &:hover {
        background-color: var(--ds-listbox-option-hover-bg-color);
    }

    &:focus-visible {
        border: var(--ds-border-width) solid
            var(--ds-listbox-option-selected-border-color);
    }
}

.ListBoxOption-module__OptionDisabled__yb8lb {
    pointer-events: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `ListBoxOption-module__Container__y7Ic9`,
	"OptionSelected": `ListBoxOption-module__OptionSelected__w5EqJ`,
	"OptionDisabled": `ListBoxOption-module__OptionDisabled__yb8lb`
};
export default ___CSS_LOADER_EXPORT___;
